const TUTOR_DOMAIN = process.env.TUTOR_DOMAIN;

export const DEFAULT_BTN_LOGO_TRAIL = `/web/src/assets/images/embed/alan_logo.png`;
export const MIC_BTN_LOGO_TRAIL = `/web/src/assets/images/embed/mic_logo.png`;


export const DEFAULT_BTN_LOGO = `https://${TUTOR_DOMAIN}${DEFAULT_BTN_LOGO_TRAIL}`;
export const MIC_BTN_LOGO = `https://${TUTOR_DOMAIN}${MIC_BTN_LOGO_TRAIL}`;
export const USER_AVATAR_LOGO = `https://${TUTOR_DOMAIN}/web/src/assets/images/embed/user-avatar.png`;